import * as React from 'react';
import './App.css';

import { BrowserRouter as Router, Route } from "react-router-dom";

import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk';

import { Provider } from 'react-redux';

import { createMuiTheme, MuiThemeProvider  } from '@material-ui/core/styles';

import rootReducer from './redux/rootReducer';

import ApiProvider from './components/ApiProvider';
import HeaderComponent from './components/HeaderComponent';
import ImprintComponent from "./components/ImprintComponent";
import JoinComponent from './components/JoinComponent';
import TeamComponent from './components/TeamComponent';

const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(thunk)
  )
);

const theme = createMuiTheme({
    palette: {
      type: 'dark',
    },
  });

class App extends React.Component {
  public render() {
    return (
      <Provider store={store}>
        <MuiThemeProvider theme={theme}>
          <ApiProvider>
            <Router>
              <div className="App">
                  <HeaderComponent/>
                  <Route exact={ true } path="/" component={JoinComponent} />
                  <Route exact={ true } path="/:team" component={TeamComponent} />
                  <ImprintComponent/>
              </div>
            </Router>
          </ApiProvider>
        </MuiThemeProvider>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx